(function () {
  'use strict';

  /* Shopify's province <option>s give names; the Storefront API wants ISO codes */
  var PROVINCE_CODES = {
    US: {
      'Alabama':'AL','Alaska':'AK','Arizona':'AZ','Arkansas':'AR','California':'CA','Colorado':'CO','Connecticut':'CT',
      'Delaware':'DE','Florida':'FL','Georgia':'GA','Hawaii':'HI','Idaho':'ID','Illinois':'IL','Indiana':'IN','Iowa':'IA',
      'Kansas':'KS','Kentucky':'KY','Louisiana':'LA','Maine':'ME','Maryland':'MD','Massachusetts':'MA','Michigan':'MI',
      'Minnesota':'MN','Mississippi':'MS','Missouri':'MO','Montana':'MT','Nebraska':'NE','Nevada':'NV','New Hampshire':'NH',
      'New Jersey':'NJ','New Mexico':'NM','New York':'NY','North Carolina':'NC','North Dakota':'ND','Ohio':'OH','Oklahoma':'OK',
      'Oregon':'OR','Pennsylvania':'PA','Rhode Island':'RI','South Carolina':'SC','South Dakota':'SD','Tennessee':'TN',
      'Texas':'TX','Utah':'UT','Vermont':'VT','Virginia':'VA','Washington':'WA','West Virginia':'WV','Wisconsin':'WI',
      'Wyoming':'WY','District of Columbia':'DC','American Samoa':'AS','Guam':'GU','Northern Mariana Islands':'MP',
      'Puerto Rico':'PR','U.S. Virgin Islands':'VI','Armed Forces Americas':'AA','Armed Forces Europe':'AE','Armed Forces Pacific':'AP'
    },
    CA: {
      'Alberta':'AB','British Columbia':'BC','Manitoba':'MB','New Brunswick':'NB','Newfoundland and Labrador':'NL',
      'Northwest Territories':'NT','Nova Scotia':'NS','Nunavut':'NU','Ontario':'ON','Prince Edward Island':'PE',
      'Quebec':'QC','Saskatchewan':'SK','Yukon':'YT'
    },
    AU: {
      'Australian Capital Territory':'ACT','New South Wales':'NSW','Northern Territory':'NT','Queensland':'QLD',
      'South Australia':'SA','Tasmania':'TAS','Victoria':'VIC','Western Australia':'WA'
    }
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  /* Basic ZIP / postal code formats (countries not listed are not format-checked) */
  var ZIP_PATTERNS = {
    US: /^\d{5}(-\d{4})?$/,
    CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    GB: /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/,
    AU: /^\d{4}$/,
    IN: /^\d{6}$/,
    DE: /^\d{5}$/,
    FR: /^\d{5}$/,
    ES: /^\d{5}$/,
    IT: /^\d{5}$/,
    NL: /^\d{4}\s?[A-Za-z]{2}$/
  };

  function zipErrorMessage(iso, countryName) {
    return iso === 'US'
      ? 'Enter a valid ZIP code for the United States'
      : 'Enter a valid postal code for ' + countryName;
  }

  function initShippingEstimator(root) {
    if (!root || root.dataset.shippingEstimatorInitialized === 'true') return;
    root.dataset.shippingEstimatorInitialized = 'true';

    var toggle = root.querySelector('[data-shipping-estimator-toggle]');
    var panel = root.querySelector('[data-shipping-estimator-panel]');
    var countrySelect = root.querySelector('[data-shipping-estimator-country]');
    var provinceSelect = root.querySelector('[data-shipping-estimator-province]');
    var provinceField = root.querySelector('[data-shipping-estimator-province-field]');
    var zipInput = root.querySelector('[data-shipping-estimator-zip]');
    var submitButton = root.querySelector('[data-shipping-estimator-submit]');
    var message = root.querySelector('[data-shipping-estimator-message]');
    var results = root.querySelector('[data-shipping-estimator-results]');
    var countriesEl = root.querySelector('[data-shipping-estimator-countries]');

    if (!toggle || !panel || !countrySelect || !provinceSelect || !zipInput || !submitButton) return;

    var domain = root.dataset.storefrontDomain;
    var token = root.dataset.storefrontToken;
    var apiVersion = root.dataset.storefrontApiVersion || '2026-07';

    var countryIso = {};
    try { countryIso = JSON.parse(countriesEl.textContent || '{}'); } catch (e) {}

    function setMessage(text, type) {
      message.textContent = text || '';
      message.className = 'shipping-estimator__message' + (type ? ' shipping-estimator__message--' + type : '');
    }

    function clearResults() { results.innerHTML = ''; }

    function formatMoney(amount, currency) {
      var n = Number(amount);
      if (!isFinite(n)) return '';
      if (n === 0) return 'FREE';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(n);
      } catch (e) {
        return n.toFixed(2) + ' ' + (currency || '');
      }
    }

    /* ---------- Country / province ---------- */

    function loadProvinces() {
      var option = countrySelect.options[countrySelect.selectedIndex];
      var iso = countryIso[countrySelect.value] || '';
      provinceSelect.innerHTML = '<option value="">Select state / province</option>';

      var provinces = [];
      try { provinces = JSON.parse((option && option.getAttribute('data-provinces')) || '[]'); } catch (e) {}
      if (!Array.isArray(provinces)) provinces = [];

      provinces.forEach(function (p) {
        var name = p[1] || p[0];
        var code = p[0] && p[0] !== p[1] ? p[0] : (PROVINCE_CODES[iso] && PROVINCE_CODES[iso][name]) || '';
        var o = document.createElement('option');
        o.value = name;
        o.textContent = name;
        o.dataset.code = code;
        provinceSelect.appendChild(o);
      });

      if (provinceField) provinceField.hidden = provinces.length === 0;
    }

    function selectCurrentCountry() {
      var current = root.dataset.currentCountryName || '';
      for (var i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value === current) { countrySelect.selectedIndex = i; break; }
      }
      loadProvinces();
    }

    /* ---------- Storefront API ---------- */

    // Merge a deferred (incremental) payload into the initial data object
    function applyIncremental(base, item) {
      var target = base;
      (item.path || []).forEach(function (key) {
        if (target && target[key] != null) target = target[key];
      });
      if (target && item.data) Object.assign(target, item.data);
    }

    // @defer responses arrive as multipart/mixed: one JSON object per part
    function parseMultipart(text, contentType) {
      var m = /boundary="?([^";]+)"?/i.exec(contentType || '');
      var boundary = m ? m[1] : '-';
      var data = null;
      var errors = [];

      text.split('--' + boundary).forEach(function (part) {
        var bodyStart = part.indexOf('\r\n\r\n');
        if (bodyStart === -1) bodyStart = part.indexOf('\n\n');
        if (bodyStart === -1) return;
        var body = part.slice(bodyStart).trim();
        if (!body || body.charAt(0) !== '{') return;

        var json;
        try { json = JSON.parse(body); } catch (e) { return; }

        if (json.errors) errors = errors.concat(json.errors);
        if (json.data && !data) data = json.data;
        if (json.incremental) {
          json.incremental.forEach(function (item) {
            if (item.errors) errors = errors.concat(item.errors);
            if (data) applyIncremental(data, item);
          });
        }
      });

      return { data: data, errors: errors };
    }

    async function storefrontRequest(query, variables) {
      if (!domain) throw new Error('Storefront API domain is missing.');
      if (!token) throw new Error('Storefront API public token is missing (add it in the Cart section settings).');

      var response = await fetch('https://' + domain + '/api/' + apiVersion + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'multipart/mixed; deferSpec=20220824, application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: variables })
      });

      var contentType = response.headers.get('content-type') || '';
      var text = await response.text();
      var payload;

      try {
        payload = contentType.indexOf('multipart') !== -1
          ? parseMultipart(text, contentType)
          : (function () { var j = JSON.parse(text); return { data: j.data, errors: j.errors || [] }; })();
      } catch (e) {
        throw new Error('Invalid response from Shopify.');
      }

      if (!response.ok || (payload.errors && payload.errors.length)) {
        throw new Error(
          payload.errors && payload.errors.length
            ? payload.errors.map(function (e) { return e.message; }).join(', ')
            : 'Storefront API request failed.'
        );
      }
      return payload.data;
    }

    async function getLiveCart() {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('Unable to read your cart.');
      return res.json();
    }

    async function createTemporaryCart(cart, address) {
      var lines = (cart.items || [])
        .filter(function (item) { return item && item.variant_id; })
        .map(function (item) {
          var line = {
            merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
            quantity: Number(item.quantity) || 1
          };
          var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
          if (plan && plan.id) line.sellingPlanId = 'gid://shopify/SellingPlan/' + plan.id;
          return line;
        });

      if (!lines.length) throw new Error('Your cart is empty.');

      var mutation =
        'mutation CartCreate($input: CartInput!) {' +
        '  cartCreate(input: $input) { cart { id } userErrors { field message } }' +
        '}';

      var data = await storefrontRequest(mutation, {
        input: {
          buyerIdentity: { countryCode: address.countryCode },
          lines: lines,
          delivery: { addresses: [{ selected: true, address: { deliveryAddress: address } }] }
        }
      });

      var result = data && data.cartCreate;
      if (!result) throw new Error('Shopify did not return a cart.');
      if (result.userErrors && result.userErrors.length) {
        throw new Error(result.userErrors.map(function (e) { return e.message; }).join(', '));
      }
      if (!result.cart || !result.cart.id) throw new Error('Unable to create shipping estimate cart.');
      return result.cart.id;
    }

    var DELIVERY_QUERY =
      'query GetDelivery($cartId: ID!) {' +
      '  cart(id: $cartId) {' +
      '    id' +
      '    cost { subtotalAmount { amount currencyCode } }' +
      '    ... @defer {' +
      '      deliveryGroups(first: 10, withCarrierRates: true) {' +
      '        nodes {' +
      '          id' +
      '          cartLines(first: 50) { nodes { quantity merchandise { ... on ProductVariant { image { url } product { title featuredImage { url } } } } } }' +
      '          deliveryOptions { handle code title description deliveryMethodType estimatedCost { amount currencyCode } }' +
      '        }' +
      '      }' +
      '    }' +
      '  }' +
      '}';

    // Turn the API response into: [{ items, names, options: [{title, description, amount, currency}] }]
    function extractGroups(cart) {
      var nodes = cart && cart.deliveryGroups && cart.deliveryGroups.nodes ? cart.deliveryGroups.nodes : [];
      return nodes.map(function (group) {
        var lines = group.cartLines && group.cartLines.nodes ? group.cartLines.nodes : [];
        var items = 0;
        var names = [];
        var images = [];
        lines.forEach(function (l) {
          items += Number(l.quantity) || 0;
          var m = l.merchandise || {};
          var t = m.product && m.product.title;
          if (t && names.indexOf(t) === -1) names.push(t);
          var img = (m.image && m.image.url) || (m.product && m.product.featuredImage && m.product.featuredImage.url);
          if (img && images.indexOf(img) === -1) images.push(img);
        });

        var options = (group.deliveryOptions || [])
          .filter(function (o) { return o && o.estimatedCost && String(o.deliveryMethodType).indexOf('PICK') === -1; })
          .map(function (o) {
            return {
              title: o.title || o.code || o.handle || 'Shipping',
              description: o.description || '',
              amount: Number(o.estimatedCost.amount),
              currency: o.estimatedCost.currencyCode
            };
          })
          .sort(function (a, b) { return a.amount - b.amount; });

        return { items: items, names: names, images: images, options: options };
      }).filter(function (g) { return g.options.length; });
    }

    async function getDelivery(cartId) {
      var cart = null;
      var groups = [];
      for (var attempt = 0; attempt < 5; attempt++) {
        var data = await storefrontRequest(DELIVERY_QUERY, { cartId: cartId });
        if (!data || !data.cart) throw new Error('Unable to retrieve shipping options.');
        cart = data.cart;
        groups = extractGroups(cart);
        if (groups.length) break;
        await wait(900); // carrier rates (UPS etc.) can arrive a moment later
      }
      return { cart: cart, groups: groups };
    }

    /* ---------- Render (checkout style) ---------- */

    function renderDelivery(delivery) {
      clearResults();
      var groups = delivery.groups;

      if (!groups.length) {
        setMessage('No shipping rates are available for this address. Please check your ZIP / postal code.', 'error');
        return;
      }

      var subtotal = Number(delivery.cart.cost.subtotalAmount.amount);
      var currency = delivery.cart.cost.subtotalAmount.currencyCode;
      var multi = groups.length > 1;

      // default selection = cheapest method of every shipment
      var picks = groups.map(function (g) { return g.options[0]; });

      var wrap = el('div', 'shipping-estimator__checkout');
      wrap.appendChild(el('div', 'shipping-estimator__results-title', 'Shipping method'));
      if (multi) {
        wrap.appendChild(el('div', 'shipping-estimator__subtitle', 'Your order will arrive in ' + groups.length + ' shipments'));
      }
      var body = el('div');
      wrap.appendChild(body);
      results.appendChild(wrap);

      function groupHead(g) {
        var head = el('div', 'shipping-estimator__group-head');
        var thumb = el('div', 'shipping-estimator__thumb');
        if (g.images[0]) {
          var img = document.createElement('img');
          img.src = g.images[0];
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        head.appendChild(thumb);

        var info = el('div', 'shipping-estimator__group-info');
        info.appendChild(el('div', 'shipping-estimator__shipment-count', g.items + (g.items === 1 ? ' item' : ' items')));
        if (g.names.length) info.appendChild(el('div', 'shipping-estimator__shipment-sub', g.names.join(', ')));
        head.appendChild(info);
        return head;
      }

      function draw() {
        body.innerHTML = '';

        groups.forEach(function (g, gi) {
          var block = el('div', 'shipping-estimator__group');
          if (multi) block.appendChild(groupHead(g));

          var list = el('div', 'shipping-estimator__methods');
          g.options.forEach(function (opt) {
            var isSelected = picks[gi] === opt;
            var label = el('label', 'shipping-estimator__method' + (isSelected ? ' is-selected' : ''));

            var radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'shipping-estimator-ship-' + gi;
            radio.checked = isSelected;
            radio.addEventListener('change', function () { picks[gi] = opt; draw(); });
            label.appendChild(radio);

            var text = el('span', 'shipping-estimator__method-text');
            var line = el('span', 'shipping-estimator__method-line');
            line.appendChild(el('strong', 'shipping-estimator__method-name', opt.title + ':'));
            line.appendChild(el('span', 'shipping-estimator__method-price', formatMoney(opt.amount, opt.currency)));
            text.appendChild(line);
            if (opt.description) text.appendChild(el('small', 'shipping-estimator__method-sub', opt.description));
            label.appendChild(text);
            list.appendChild(label);
          });

          block.appendChild(list);
          body.appendChild(block);
        });

        var shipping = picks.reduce(function (t, o) { return t + o.amount; }, 0);
        var totals = el('div', 'shipping-estimator__totals');
        [
          ['Subtotal', formatMoney(subtotal, currency), ''],
          ['Shipping', formatMoney(shipping, currency), ''],
          ['Estimated total', formatMoney(subtotal + shipping, currency), ' shipping-estimator__totals-row--grand']
        ].forEach(function (r) {
          var row = el('div', 'shipping-estimator__totals-row' + r[2]);
          row.appendChild(el('span', '', r[0]));
          row.appendChild(el('span', '', r[1]));
          totals.appendChild(row);
        });
        body.appendChild(totals);
      }

      draw();
    }

    /* ---------- Split the cart into shipments (like checkout) ---------- */

    // Shopify's cart API merges every shipping profile into ONE combined rate (named just "Shipping").
    // To get the real per-profile rates, we rate each line on its own, group lines that have the same
    // set of shipping methods (= same shipping profile), then rate each group together.

    async function createCartSafe(items, address) {
      try {
        return await createTemporaryCart({ items: items }, address);
      } catch (err) {
        if (address.provinceCode && /province|zone|region/i.test(err.message)) {
          delete address.provinceCode; // Shopify rejected the province code: continue with country + zip
          return await createTemporaryCart({ items: items }, address);
        }
        throw err;
      }
    }

    async function rateItems(items, address) {
      var cartId = await createCartSafe(items, address);
      return getDelivery(cartId);
    }

    function signature(groups) {
      var titles = [];
      groups.forEach(function (g) {
        g.options.forEach(function (o) { if (titles.indexOf(o.title) === -1) titles.push(o.title); });
      });
      return titles.sort().join('|');
    }

    function describeItems(items) {
      var count = 0, names = [], images = [];
      items.forEach(function (it) {
        count += Number(it.quantity) || 0;
        if (it.product_title && names.indexOf(it.product_title) === -1) names.push(it.product_title);
        var img = it.image || (it.featured_image && it.featured_image.url);
        if (img && images.indexOf(img) === -1) images.push(img);
      });
      return { items: count, names: names, images: images };
    }

    async function buildShipments(liveCart, address) {
      var items = (liveCart.items || []).filter(function (it) { return it && it.variant_id; });
      if (!items.length) throw new Error('Your cart is empty.');

      var subtotal = {
        cost: { subtotalAmount: { amount: String(liveCart.total_price / 100), currencyCode: liveCart.currency } }
      };

      var shipments = [];

      // One item, or a very large cart: a single estimate is enough
      if (items.length === 1 || items.length > 12) {
        var whole = await rateItems(items, address);
        whole.groups.forEach(function (g) {
          shipments.push(Object.assign({}, describeItems(items), { options: g.options }));
        });
        return { cart: subtotal, groups: shipments };
      }

      // 1) rate every line on its own (first one alone so the province fallback is settled once)
      var perItem = [await rateItems([items[0]], address)];
      perItem = perItem.concat(await Promise.all(items.slice(1).map(function (it) { return rateItems([it], address); })));

      // 2) group lines that offer the same shipping methods
      var clusters = {};
      var order = [];
      items.forEach(function (it, i) {
        var sig = signature(perItem[i].groups);
        if (!sig) throw new Error('No shipping rates are available for this address. Please check your ZIP / postal code.');
        if (!clusters[sig]) { clusters[sig] = { items: [], first: i }; order.push(sig); }
        clusters[sig].items.push(it);
      });

      // 3) rate each group together (real combined price for that shipment)
      var rated = await Promise.all(order.map(function (sig) {
        var c = clusters[sig];
        return c.items.length === 1 ? Promise.resolve(perItem[c.first]) : rateItems(c.items, address);
      }));

      order.forEach(function (sig, i) {
        var c = clusters[sig];
        rated[i].groups.forEach(function (g) {
          shipments.push(Object.assign({}, describeItems(c.items), { options: g.options }));
        });
      });

      return { cart: subtotal, groups: shipments };
    }

    /* ---------- Estimate ---------- */

    async function estimateShipping() {
      clearResults();

      var countryName = countrySelect.value;
      var countryCode = countryIso[countryName] || '';
      var zip = zipInput.value.trim();
      var provinceOption = provinceSelect.options[provinceSelect.selectedIndex];
      var needsProvince = provinceSelect.options.length > 1;
      var provinceCode = provinceOption && provinceOption.dataset ? provinceOption.dataset.code || '' : '';

      if (!countryName) return setMessage('Please select a country.', 'error');
      if (!countryCode) return setMessage('Sorry, we cannot estimate shipping for this country.', 'error');
      if (needsProvince && !provinceSelect.value) return setMessage('Please select a state / province.', 'error');
      if (!zip) { zipInput.focus(); return setMessage('Please enter your ZIP / postal code.', 'error'); }
      if (ZIP_PATTERNS[countryCode] && !ZIP_PATTERNS[countryCode].test(zip)) {
        zipInput.setAttribute('aria-invalid', 'true');
        zipInput.focus();
        return setMessage(zipErrorMessage(countryCode, countryName), 'error');
      }
      zipInput.removeAttribute('aria-invalid');

      submitButton.disabled = true;
      submitButton.textContent = 'Estimating...';
      setMessage('Calculating shipping rates...');

      try {
        var liveCart = await getLiveCart();
        var address = { countryCode: countryCode, zip: zip };
        if (provinceCode) address.provinceCode = provinceCode;

        var delivery = await buildShipments(liveCart, address);
        setMessage('');
        renderDelivery(delivery);
      } catch (error) {
        console.error('Shipping estimator error:', error);
        clearResults();
        var msg = error && error.message ? error.message : 'Unable to calculate shipping rates.';
        if (/zip|postal/i.test(msg)) {
          zipInput.setAttribute('aria-invalid', 'true');
          msg = zipErrorMessage(countryCode, countryName);
        }
        setMessage(msg, 'error');
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = 'Estimate';
      }
    }

    /* ---------- Events ---------- */

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.classList.toggle('shipping-estimator__panel--open', !open);
    });

    countrySelect.addEventListener('change', function () {
      loadProvinces();
      clearResults();
      setMessage('');
    });

    submitButton.addEventListener('click', function (e) { e.preventDefault(); estimateShipping(); });

    zipInput.addEventListener('input', function () {
      zipInput.removeAttribute('aria-invalid');
      if (message.classList.contains('shipping-estimator__message--error')) setMessage('');
    });

    zipInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); estimateShipping(); }
    });

    selectCurrentCountry();
  }

  function init() {
    document.querySelectorAll('[data-shipping-estimator]').forEach(initShippingEstimator);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();